import { IManageTestUser } from 'APIPackage/ManageTestUserModule/interface/IManageTestUser';
import { TableColumnSortEnum } from 'CorePackage/MainModule/enums/TableColumnSortEnum';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

export const manageTestUsersTableColumns: ITableColumn<IManageTestUser>[] = [
  { id: 'fullName', name: 'ФИО', sort: TableColumnSortEnum.ASC, isSelected: true },
  { id: 'username', name: 'Логин', sort: TableColumnSortEnum.NONE, isSelected: true },
  { id: 'role', name: 'Роль', sort: TableColumnSortEnum.NONE, isSelected: true },
  { id: 'isTestUser', name: 'Признак "Тестовый"', sort: TableColumnSortEnum.NONE, isSelected: true },
];
